// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"b603e61d","596":"8e309fa1"}[chunkId] + ".chunk.js";
};